module.exports = __webpack_public_path__ + "static/media/rouge.da0ba279.png";